// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================

const baseKey = 'tenant';

export const tenantKeys = {
  current: () => [baseKey, 'current'],
  one: ({ id }: { id: NonNullable<string> }) => [baseKey, 'one', { id }],
  hostname: ({ hostname }: { hostname: string }) => [
    baseKey,
    'hostname',
    { hostname },
  ],
  all: () => [baseKey],
};
